class ScrollRevealHandler {
  private observer: IntersectionObserver;
  private elements: NodeListOf<Element>;
  private imagesLoaded: boolean = false;

  constructor() {
    this.elements = document.querySelectorAll(
      ".lightbox-article .header, " +
        ".lightbox-article .introParagraph, " +
        ".lightbox-article .row, " +
        ".item-wrapper .header, " +
        ".item-wrapper .introParagraph, " +
        ".item-wrapper .row"
    );

    console.log(
      `ScrollRevealHandler initialized with ${this.elements.length} elements`
    );

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.imagesLoaded) {
            console.log("Revealing element:", entry.target);
            entry.target.classList.add("revealed");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    this.init();
  }

  private init(): void {
    this.elements.forEach((element) => {
      element.classList.add("scroll-reveal");
      this.observer.observe(element);
    });

    // Wait for all images to load before revealing
    this.waitForImages();

    // Listen for lightbox content loaded events to observe new elements
    document.addEventListener("lightboxContentLoaded", () => {
      this.refreshElements();
    });
  }

  private waitForImages(): void {
    const images = Array.from(
      document.querySelectorAll(".item-wrapper img, .lightbox-article img")
    ) as HTMLImageElement[];

    if (images.length === 0) {
      // No images, reveal immediately
      this.imagesLoaded = true;
      this.revealVisibleElements();
      return;
    }

    let loadedCount = 0;
    const totalImages = images.length;

    const checkAllLoaded = () => {
      loadedCount++;
      if (loadedCount >= totalImages) {
        this.imagesLoaded = true;
        console.log(`All ${totalImages} images loaded, revealing elements`);
        this.revealVisibleElements();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        checkAllLoaded();
      } else {
        img.addEventListener("load", checkAllLoaded);
        img.addEventListener("error", checkAllLoaded); // Count errors as loaded to prevent blocking
      }
    });
  }

  private revealVisibleElements(): void {
    // Manually trigger reveal for elements that are already visible
    this.elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
      if (isVisible) {
        element.classList.add("revealed");
      }
    });
  }

  private refreshElements(): void {
    // Disconnect existing observer
    this.observer.disconnect();

    // Re-query elements
    this.elements = document.querySelectorAll(
      ".lightbox-article .header, " +
        ".lightbox-article .introParagraph, " +
        ".lightbox-article .row, " +
        ".item-wrapper .header, " +
        ".item-wrapper .introParagraph, " +
        ".item-wrapper .row"
    );

    // Re-observe all elements
    this.elements.forEach((element) => {
      element.classList.add("scroll-reveal");
      this.observer.observe(element);
    });

    // Reset images loaded flag and wait for new images
    this.imagesLoaded = false;
    this.waitForImages();
  }

  public destroy(): void {
    this.observer.disconnect();
  }
}

export default ScrollRevealHandler;
